import { Component, Input, SimpleChanges } from "@angular/core";

@Component({
  selector: "app-aul-003-24",
  standalone: true,
  imports: [],
  templateUrl: "./aul-003-24.component.html",
  styleUrl: "./aul-003-24.component.scss",
})
export class Aul00324Component {
  @Input() policyDetails!: any;
  @Input() documentFlags: any;
  @Input() set addressState(value: string) {
    this._addressState = value?.toUpperCase() ?? '';
  }
    
  _addressState: string = '';
  
  get formattedState(): string {
    return this._addressState;
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    if (changes["policyDetails"]) {
      this.policyDetails = changes["policyDetails"].currentValue?.aul_003_24;
    }
  }
}
